'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');

const MaximumCacheDurationInMs=timespan.fromMinutes(5).totalMilliseconds();let

PersonalIncidentsService=class PersonalIncidentsService extends BaseService{
constructor(socketService,dateService){
super();
this._socketService=socketService;
this._dateService=dateService;

this.reset();
}

reset(){
this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId={};
this._lastIncidentUnixFetchTimeByPersonId={};

this._resetIncidentTypesCache();
}

async getIncidentTypes(){
const currentUnixFetchTime=this._dateService.now().getTime();
if(_.exists(this._cachedIncidentTypes)){
if(currentUnixFetchTime-this._lastIncidentTypesUnixFetchTime<=MaximumCacheDurationInMs){
return this._cachedIncidentTypes;
}else{
this.reset();
}
}

const incidentTypesResponse=await this._socketService.sendAndWaitForResponse('GetIncidentTypes',void 0,{
timeoutInSeconds:3000,
retryOptions:{
retries:5,
maxTimeout:10000},

throwOnUnexpectedError:!0});


if(!SocketResponse.succeeded(incidentTypesResponse)){
throw new Error(`Error getting incident types: ${JSON.stringify(incidentTypesResponse)}`);
}

const incidentTypes=incidentTypesResponse.body;

this._cachedIncidentTypes={
incidentTypes,
incidentTypesByCode:_.keyBy(incidentTypes,'code')};

this._lastIncidentTypesUnixFetchTime=currentUnixFetchTime;

return this._cachedIncidentTypes;
}

_resetIncidentTypesCache(){
this._cachedIncidentTypes=null;
this._lastIncidentTypesUnixFetchTime=null;
}

async getAllIncidentsFor(personId){
_.ensureInstanceOf('string',personId);

let{incidentTypes,incidentTypesByCode}=await this.getIncidentTypes();
if(incidentTypes.length===0){
return{
incidentTypes:[],
incidents:[],
dayOfLastPurgedIncident:null};

}

let incidents;
let dayOfLastPurgedIncident;
const currentUnixFetchTime=this._dateService.now().getTime();
if(_.exists(this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId])&&
currentUnixFetchTime-this._lastIncidentUnixFetchTimeByPersonId[personId]<=MaximumCacheDurationInMs){
incidents=this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId].incidents;
dayOfLastPurgedIncident=this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId].dayOfLastPurgedIncident;
}else{
const incidentsResponse=await this._socketService.sendAndWaitForResponse('GetIncidents',{personId});
if(!SocketResponse.succeeded(incidentsResponse)){
throw new Error(`Error getting incidents: ${JSON.stringify(incidentsResponse)}`);
}

incidents=incidentsResponse.body.incidents;
dayOfLastPurgedIncident=_.exists(incidentsResponse.body.dayOfLastPurgedIncident)?
new CalendarDay(incidentsResponse.body.dayOfLastPurgedIncident):
null;

const numIncidents=incidents.length;
for(var i=0;i<numIncidents;i++){
if(!_.exists(incidentTypesByCode[incidents[i].code])){
this._resetIncidentTypesCache();
const regottenIncidentTypeInfo=await this.getIncidentTypes();
incidentTypes=regottenIncidentTypeInfo.incidentTypes;
incidentTypesByCode=regottenIncidentTypeInfo.incidentTypesByCode;
}
incidents[i].time=new Date(incidents[i].time);
incidents[i].description=incidentTypesByCode[incidents[i].code].description;
}

this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId]={incidents,dayOfLastPurgedIncident};
this._lastIncidentUnixFetchTimeByPersonId[personId]=currentUnixFetchTime;
}

return{
incidentTypes,
incidents,
dayOfLastPurgedIncident};

}};


module.exports=PersonalIncidentsService;
//# sourceMappingURL=personalIncidentsService.js.map
